const primaryColor = 'rgba(241, 26, 41, 1)';
const primaryColorHover = 'rgba(164, 0, 28, 1)';
const secondaryColor = 'rgba(255, 255, 255, 1)';
const secondaryColorHover = 'rgba(199, 224, 244, 1)';

export const webChatStyleOptions = {
    hideUploadButton: true,
    accent: primaryColor,
    subtle: 'rgba(128, 128, 128, 1)',
    sendBoxButtonColor: primaryColor,
    sendBoxButtonColorOnHover: primaryColorHover,
    sendBoxButtonColorOnFocus: primaryColorHover,
    sendBoxButtonColorOnDisabled: secondaryColorHover,
    suggestedActionBackground: secondaryColor,
    suggestedActionBorderColor: primaryColor,
    suggestedActionTextColor: primaryColor,
    suggestedActionDisabledBorderColor: secondaryColorHover,
    suggestedActionDisabledTextColor: 'rgba(154, 154, 154, 1)',
    transcriptOverlayButtonBackground: primaryColor,
    transcriptOverlayButtonBackgroundOnHover: primaryColorHover,
    transcriptOverlayButtonBackgroundOnFocus: primaryColorHover,
    transcriptOverlayButtonColor: secondaryColor,
    transcriptOverlayButtonColorOnHover: secondaryColor,
    transcriptOverlayButtonColorOnFocus: secondaryColor
};
